/* SG DESKTOP CATEGORY DROPDOWN v1 */
(function () {
  'use strict';

  function transformLegacyNavigation() {
    if (window.innerWidth < 990 || document.querySelector('#Details-DesktopCategories')) return;

    var nav = document.querySelector('.header__inline-menu');
    var list = nav && nav.querySelector(':scope > ul');
    if (!list || list.classList.contains('sg-desktop-menu__list')) return;

    var items = Array.prototype.slice.call(list.children);
    if (items.length < 2) return;

    var categoryItems = [];
    var infoItems = [];
    items.forEach(function (item) {
      var link = item.querySelector(':scope > a');
      var href = link ? (link.getAttribute('href') || '') : '';
      if (href.indexOf('informacion-de-compra') !== -1) infoItems.push(item);
      else categoryItems.push(item);
    });
    if (!categoryItems.length) return;

    nav.classList.add('sg-desktop-menu');
    list.classList.add('sg-desktop-menu__list');

    var categoryItem = document.createElement('li');
    categoryItem.className = 'sg-desktop-menu__categories';
    var details = document.createElement('details');
    details.id = 'Details-DesktopCategories';
    details.className = 'sg-desktop-menu__details';

    var summary = document.createElement('summary');
    summary.className = 'header__menu-item list-menu__item link focus-inset sg-desktop-menu__trigger';
    summary.setAttribute('aria-controls', 'DesktopCategoriesPanel');
    summary.innerHTML = '<span>Categorías</span><span aria-hidden="true">⌄</span>';
    details.appendChild(summary);

    var panel = document.createElement('div');
    panel.id = 'DesktopCategoriesPanel';
    panel.className = 'sg-desktop-menu__panel';
    var inner = document.createElement('div');
    inner.className = 'sg-desktop-menu__panel-inner';
    inner.innerHTML = '<p class="sg-desktop-menu__eyebrow">Explora Soriega</p>';
    var grid = document.createElement('ul');
    grid.className = 'sg-desktop-menu__grid';
    grid.setAttribute('role', 'list');

    categoryItems.forEach(function (item) {
      var link = item.querySelector(':scope > a');
      if (!link) return;
      var gridItem = document.createElement('li');
      var categoryLink = document.createElement('a');
      categoryLink.className = 'sg-desktop-menu__category-link';
      categoryLink.href = link.href;
      categoryLink.innerHTML =
        '<span>' + link.textContent.trim() + '</span>' +
        '<span class="sg-desktop-menu__arrow" aria-hidden="true">↗</span>';
      gridItem.appendChild(categoryLink);
      grid.appendChild(gridItem);
    });

    inner.appendChild(grid);
    panel.appendChild(inner);
    details.appendChild(panel);
    categoryItem.appendChild(details);
    list.replaceChildren.apply(list, [categoryItem].concat(infoItems));
  }

  function initDesktopCategoryDropdown() {
    var details = document.querySelector('#Details-DesktopCategories');
    var panel = document.querySelector('#DesktopCategoriesPanel');
    if (!details || !panel || details.dataset.sgReady === 'true') return;
    details.dataset.sgReady = 'true';

    function positionPanel() {
      var header = document.querySelector('.header-wrapper');
      if (!header) return;
      document.documentElement.style.setProperty(
        '--sg-desktop-menu-top',
        header.getBoundingClientRect().bottom + 'px'
      );
    }

    function syncState() {
      var trigger = details.querySelector('summary');
      if (trigger) trigger.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) positionPanel();
    }

    details.addEventListener('toggle', syncState);
    document.addEventListener('click', function (event) {
      if (details.open && !details.contains(event.target)) details.removeAttribute('open');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) {
        details.removeAttribute('open');
        details.querySelector('summary').focus();
      }
    });
    window.addEventListener('resize', positionPanel, { passive: true });
    window.addEventListener('scroll', positionPanel, { passive: true });
    positionPanel();
    syncState();
  }

  function bootDesktopCategoryDropdown() {
    transformLegacyNavigation();
    initDesktopCategoryDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDesktopCategoryDropdown);
  } else {
    bootDesktopCategoryDropdown();
  }
  window.addEventListener('resize', bootDesktopCategoryDropdown, { passive: true });
})();